import styled from 'styled-components';

export const TourRenderSceneFlat360Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.04);
  user-select: none;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  .--image-container {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.1s ease-in-out;
    .--image {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      pointer-events: none;
    }
  }
  .--navigation-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(50, 50, 50, 0.6);
    color: white;
    border: none;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 10;
    transition: opacity 0.3s ease-in-out;
    opacity: 0.7;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    &:hover {
      background-color: rgba(50, 50, 50, 0.8);
      opacity: 1;
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      background-color: rgba(50, 50, 50, 0.4);
    }
    &.--navigation-button-left {
      left: 15px;
    }
    &.--navigation-button-right {
      right: 15px;
    }
  }
`;
